/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Bell_Activity_Saves_ManyInputs */

const en_bell_activity_saves_many = /** @type {(inputs: Bell_Activity_Saves_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} saves`)
};

/**
* | output |
* | --- |
* | "{count} saves" |
*
* @param {Bell_Activity_Saves_ManyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_activity_saves_many = /** @type {((inputs: Bell_Activity_Saves_ManyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Activity_Saves_ManyInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_activity_saves_many(inputs)
});